export default __webpack_public_path__ + "static/media/product11.54e29552.webp";